<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>基本信息</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="合同编号：">{{queryParams.contractCode}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户合同编号：">{{queryParams.customerContractCode}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称：">
              <span class="approval" @click="onCusName">{{queryParams.cusName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="合同金额：">{{ queryParams.contractTotal|priceFilterNum }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已收账款：">{{ queryParams.accountsReceived|priceFilterNum }}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="应收账款：">{{ queryParams.accountsCollect|priceFilterNum }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已到期应收账款：">{{ queryParams.accountsDue|priceFilterNum }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="未到期应收账款：">{{ queryParams.accountsOutstanding|priceFilterNum }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>产品清单</span>
      </div>
      <!-----------------------                期货             ------------------------------>
      <div v-if="VoList">
        <div v-for="item in VoList" :key="item.id">
          <el-row style="margin:30px 0 20px">
            <el-col :span="8">{{item.shipName}}：{{ item.shipPrice|priceFilter }}</el-col>
            <el-col :span="8">本期货款：{{ item.shipTotal|priceFilter }}</el-col>
            <el-col :span="8">预计付款时间：{{ item.shipPayDate }}</el-col>
          </el-row>
          <el-table
            border
            :header-cell-style="tableHeader"
            :data="item.orderStockupSourseStateVoList"
          >
            <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
            <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
            <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
            <el-table-column label="型号" show-overflow-tooltip>
              <template slot-scope="scope">
                <div
                  class="approval line-limit-length"
                  @click="onProductDetail(scope.row)"
                >{{ scope.row.proType }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="count" label="数量"></el-table-column>
            <el-table-column prop="cbUnit" label="单位"></el-table-column>
            <el-table-column prop="cbExtimeValue" label="货期" width="65">
              <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
            </el-table-column>
            <el-table-column prop="cbPrice" label="销售单价">
              <template slot-scope="scope">{{scope.row.cbPrice|priceFilter}}</template>
            </el-table-column>
            <el-table-column prop="cbDiscount" label="折扣">
              <template slot-scope="scope">{{scope.row.cbDiscount|perCentFilter}}</template>
            </el-table-column>
            <el-table-column label="毛利率">
              <template slot-scope="scope">{{scope.row.cbRate|perCentFilter}}</template>
            </el-table-column>
            <el-table-column prop="cbUnitPrice" label="供货单价">
              <template slot-scope="scope">{{scope.row.cbUnitPrice|priceFilter}}</template>
            </el-table-column>
            <el-table-column prop="cbFacePrice" label="面价">
              <template slot-scope="scope">{{scope.row.cbFacePrice|priceFilter}}</template>
            </el-table-column>
            <el-table-column label="备货状态">
              <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
            </el-table-column>
            <el-table-column label="发货状态">
              <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
            </el-table-column>
            <el-table-column label="开票状态">
              <template
                slot-scope="scope"
              >{{scope.row.invoiceState===1?'已开票':scope.row.invoiceState===2?'开票审核':'未开票'}}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-----------------------                非期货             ------------------------------>

      <el-table
        v-else
        style="margin-top:20px"
        border
        :header-cell-style="tableHeader"
        :data="list"
        max-height="378"
      >
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proName" label="产品名称" show-overflow-tooltip></el-table-column>
        <el-table-column label="型号" show-overflow-tooltip>
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onProductDetail(scope.row)"
            >{{ scope.row.proType }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="count" label="数量"></el-table-column>
        <el-table-column prop="cbUnit" label="单位"></el-table-column>
        <el-table-column prop="cbExtimeValue" label="货期" width="65">
          <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
        </el-table-column>
        <el-table-column prop="cbPrice" label="销售单价">
          <template slot-scope="scope">{{scope.row.cbPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="cbDiscount" label="折扣">
          <template slot-scope="scope">{{scope.row.cbDiscount|perCentFilter}}</template>
        </el-table-column>
        <el-table-column label="毛利率">
          <template slot-scope="scope">{{scope.row.cbRate|perCentFilter}}</template>
        </el-table-column>
        <el-table-column prop="cbUnitPrice" label="供货单价">
          <template slot-scope="scope">{{scope.row.cbUnitPrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column prop="cbFacePrice" label="面价">
          <template slot-scope="scope">{{scope.row.cbFacePrice|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="备货状态">
          <template slot-scope="scope">{{scope.row.stockupState|stockupStateFilter}}</template>
        </el-table-column>
        <el-table-column label="发货状态">
          <template slot-scope="scope">{{scope.row.deliverState|deliverStateFilter}}</template>
        </el-table-column>
        <el-table-column label="开票状态">
          <template
            slot-scope="scope"
          >{{scope.row.invoiceState===1?'已开票':scope.row.invoiceState===2?'开票审核':'未开票'}}</template>
        </el-table-column>
      </el-table>
      <h4>总计</h4>
      <el-table border :header-cell-style="tableHeader" :data="listTotal">
        <el-table-column label="销售总额" prop="totalQuotation">
          <template slot-scope="scope">{{scope.row.totalQuotation|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="供货总额" prop="actualPriceQuotation">
          <template slot-scope="scope">{{scope.row.actualPriceQuotation|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="面价总额" prop="cbFacePrice">
          <template slot-scope="scope">{{scope.row.cbFacePrice|priceFilter}}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>坏账详情</span>
      </div>
      <el-form label-width="110px" style="margin-top:20px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="申请坏账金额：">{{queryParams.accountsCollect|priceFilter}}</el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="申请原因：">
              <el-input type="textarea" v-model="mark" :rows="3" placeholder="请填写申请原因！"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="config-instruction">
          <el-button @click="onInitiateApplication" type="primary">发起申请</el-button>
          <div style="margin-top:14px">
            <i class="el-icon-warning-outline"></i>
            <span>若产品清单中包含未备货或未发货的产品，不允许发起坏账申请。</span>
          </div>
        </div>
      </el-form>
    </div>
    <!------------ 发起申请 ------------>
    <open-or-close
      ref="OpenOrClose"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import { queryOrderBaseByObcId, financeBadDebtSave } from '@/api/sell/sellManage'
export default {
  components: {
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      list: [], // 非期货列表
      VoList: [], // 期货列表
      queryParams: {},
      listTotal: [], // 总计列表
      content: '',
      title: '',
      mark: '', // 原因
      flag: false,
      badCount: '' // 本次申请坏账金额
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.prodId } })
    },
    // onContract () {  // 跳转合同
    //   this.$router.push({
    //     name: 'contractEdit',
    //     query: {
    //       id: this.$route.query.id,
    //       cusId: this.queryParams.cusId
    //     }
    //   })
    // },
    onCusName() {
      this.$router.push({
        name: 'customer/details',
        query: {
          id: this.queryParams.cusId
        }
      })
    },
    // 发起申请
    onInitiateApplication() {
      if (!this.mark) {
        this.$message.error('请填写申请原因')
        return
      }
      if (!this.flag) {
        this.$message.error('产品清单中包含未发货产品，请先发起售后退货流程')
        return
      }
      this.title = '确认坏账申请'
      this.content = '确认后将由上级主管审批，并制定费用结算方案。'
      this.$refs.OpenOrClose.onInitial()
    },
    // 确认发起申请
    onUpdataState() {
      const params = {
        ...this.queryParams,
        mark: this.mark,
        orderContractNumber: this.queryParams.contractCode,
        badCount: this.queryParams.accountsCollect,
        obId: this.$route.query.id
      }
      financeBadDebtSave(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已发起坏账申请，请等待上级审批')
            this.$router.push({
              name: 'badDebtDetails',
              query: { fbcId: res.data.obj }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    getList() {
      queryOrderBaseByObcId(this.$route.query.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.flag = res.data.obj.flag
            this.queryParams = res.data.obj
            this.VoList = res.data.obj.orderShipmentStateVoList
            this.list = res.data.obj.orderContractContentStateVoList
            const obj = {
              totalQuotation: res.data.obj.totalQuotation,
              actualPriceQuotation: res.data.obj.actualPriceQuotation,
              cbFacePrice: res.data.obj.cbFacePrice
            }
            this.listTotal.push(obj)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
